import { createFeatureSelector, createSelector } from '@ngrx/store';

import { manualFlowFeatureKey, ManualFlowState } from 'app/state/manual-flow/manual-flow.reducer';

export const selectManualFlowState = createFeatureSelector<ManualFlowState>(manualFlowFeatureKey);

export const selectManualFlowRegistrationData = createSelector(selectManualFlowState, (state) => state.data);

export const selectManualInputComponentState = createSelector(
    selectManualFlowState,
    (state) => state.manualInputComponentState,
);

export const selectManualFlowActivity = createSelector(selectManualFlowState, (state) => state.activity);
